<div class="page-content">


    <div class="container mt-5">
        <div class="section">
            <div class="section-header">
                <h3>tables</h3>
            </div>
            <div class="section-content">
                <table class="table table-simple">
                    <thead>
                    <tr>
                        <td>Nazwa</td>
                        <td class="text-accent text-right">
                            {{'BUTTON.DOWNLOAD_ALL' | translate}}<i class="icon-download-2 ml-2"></i>
                        </td>
                    </tr>
                    </thead>

                    <tbody>
                    <tr>
                        <td>Lorem ipusm dolor</td>
                        <td class="text-accent text-right"><i class="icon-download-2"></i></td>
                    </tr>
                    <tr>
                        <td>Lorem ipusm dolor</td>
                        <td class="text-accent text-right"><i class="icon-download-2"></i></td>
                    </tr>
                    <tr>
                        <td>Lorem ipusm dolor</td>
                        <td class="text-accent text-right"><i class="icon-download-2"></i></td>
                    </tr>
                    </tbody>
                </table>

                <div class="separator"></div>
                <hr>
                <div class="separator"></div>

                <table class="table table-lg">
                    <colgroup>
                        <col width="30px">
                        <col>
                        <col>
                        <col>
                    </colgroup>
                    <thead>
                    <tr>
                        <th></th>
                        <th>{{'REGISTRY.INSURED' | translate}}</th>
                        <th class="text-right">{{'REGISTRY.PREMIUM' | translate}}</th>
                        <th>{{'REGISTRY.CALCULATION_TYPE' | translate}}</th>
                        <th>{{'REGISTRY.INSURANCE_PERIOD' | translate}}</th>
                        <th class="text-right">{{'REGISTRY.OFFER_NR_CALCULATION' | translate}}</th>
                        <th>{{'REGISTRY.AGENT_OFWCA' | translate}}</th>
                        <th></th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr>
                        <td class="has-icon"><i class="icon-home"></i></td>
                        <td>Patryk Mińkowski</td>
                        <td class="text-right">192 zł</td>
                        <td>Oferta</td>
                        <td>2020-06-03- 2021 06-02</td>
                        <td class="text-right">343905490390934</td>
                        <td>01727, NBY000051, Kowalski Jan</td>
                        <td class="has-icon">
                            <button class="btn btn-link btn-slim"><i class="icon-arrow-right"></i></button>
                        </td>
                    </tr>

                    </tbody>
                </table>


                <div class="separator"></div>
                <hr>
                <div class="separator"></div>
                <mat-radio-group aria-label="Select an option">

                    <table class="table table-simple">
                        <colgroup>
                            <col width="30px">
                            <col>
                            <col>
                            <col>
                            <col>
                            <col>
                            <col>
                            <col>
                            <col width="50px">
                            <col width="50px">
                            <col width="50px">
                        </colgroup>

                        <thead>
                        <tr>
                            <td></td>

                            <td>Eurotax</td>

                            <td>Marka</td>

                            <td>Model</td>

                            <td>Typ</td>

                            <td>Lata produkcji</td>

                            <td class="text-right">Pojemność</td>

                            <td class="text-right">Moc</td>

                            <td>Skrzynia biegów</td>

                            <td class="text-right">Liczba biegów</td>

                            <td class="text-right">Liczba miejsc</td>
                        </tr>

                        </thead>

                        <tbody>
                        <tr>
                            <td>
                                <!--                        <app-checkbox [(ngModel)]="checked"></app-checkbox>-->
                                <mat-radio-button value="1"></mat-radio-button>
                            </td>

                            <td>129585</td>

                            <td>BMW</td>

                            <td>Seria 2 Cabrion[F23] 17-</td>

                            <td>2018d</td>

                            <td>2017-2019</td>

                            <td class="text-right">1995</td>

                            <td class="text-right">110</td>

                            <td>M</td>

                            <td class="text-right">6</td>

                            <td class="text-right">4</td>
                        </tr>
                        <tr>
                            <td>
                                <!--                        <app-checkbox [(ngModel)]="checked"></app-checkbox>-->

                                <mat-radio-button value="2"></mat-radio-button>
                            </td>

                            <td>129585</td>

                            <td>BMW</td>

                            <td>Seria 2 Cabrion[F23] 17-</td>

                            <td>2018d</td>

                            <td>2017-2019</td>

                            <td class="text-right">1995</td>

                            <td class="text-right">110</td>

                            <td>M</td>

                            <td class="text-right">6</td>

                            <td class="text-right">4</td>
                        </tr>
                        </tbody>
                    </table>

                </mat-radio-group>
            </div>
        </div>
    </div>

    <div class="container mt-5">
        <div class="section">
            <div class="section-header">
                <h3>Buttons</h3>
            </div>
            <div class="section-content">
                <div class="row form-group">
                    <div class="col-3">
                        <button class="btn btn-primary">btn-primary</button>
                    </div>


                    <div class="col-3">
                        <button class="btn btn-secondary">btn-secondary</button>
                    </div>

                    <div class="col-3">
                        <button class="btn btn-link" type="button">Link</button>
                    </div>

                    <!--
                                    <div class="col-3">
                                        <button class="btn btn-secondary btn-block">btn-secondary block</button>
                                    </div>-->
                </div>

                <div class="row form-group">
                    <div class="col-3">
                        <button class="btn btn-primary" disabled>btn-primary</button>
                    </div>


                    <div class="col-3">
                        <button class="btn btn-secondary" disabled>btn-secondary</button>
                    </div>

                    <div class="col-3">
                        <button class="btn btn-link" type="button" disabled>Link</button>
                    </div>

                    <!--
                                    <div class="col-3">
                                        <button class="btn btn-secondary btn-block">btn-secondary block</button>
                                    </div>-->
                </div>
            </div>
        </div>
    </div>

    <div class="container mt-5">
        <div class="section">
            <div class="section-header">
                <h3>Forms</h3>
            </div>
            <div class="section-content">

                <div class="row form-row">
                    <div class="mobile col-4">
                        <mat-form-field>
                            <mat-label>Input label</mat-label>
                            <input matInput>
                        </mat-form-field>
                    </div>
                    <div class="mobile col-4">
                        <mat-form-field>
                            <mat-label>Input label with placeholder</mat-label>
                            <input matInput placeholder="Placeholder">
                        </mat-form-field>
                    </div>
                    <div class="mobile col-4">
                        <mat-form-field>
                            <mat-label>Select label</mat-label>
                            <mat-select placeholder="Status umowy">
                                <mat-option [value]="null">-wybierz-</mat-option>
                                <mat-option>
                                    lorem
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>
                </div>

                <div class="row form-row">
                    <div class="mobile col-4">
                        <mat-form-field>
                            <mat-label>Input disabled</mat-label>
                            <input disabled matInput
                                   type="text">
                        </mat-form-field>
                    </div>

                    <div class="mobile col-4">
                        <mat-form-field>
                            <mat-label>Input with placeholder disabled</mat-label>
                            <input disabled matInput
                                   placeholder="placeholder" type="text">
                        </mat-form-field>
                    </div>

                    <div class="mobile col-4">
                        <mat-form-field>
                            <mat-label>Select disabled</mat-label>

                            <mat-select disabled placeholder="Status umowy">
                                <mat-option [value]="null">-wybierz-</mat-option>
                                <mat-option>
                                    select value
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>
                </div>

                <div class="row form-row">
                    <div class="col-4">
                        <app-input [label]="'app input'"
                                   [placeholder]="'LABEL.SEARCH' | translate"
                                   autocomplete="false"
                                   suffixIconClass="icon-search"></app-input>
                    </div>
                </div>

                <div class="row form-row">
                    <div class="col-md-4">
                        <mat-form-field>
                            <mat-label>Autosize textarea max 5</mat-label>
                            <textarea #autosize="cdkTextareaAutosize"
                                      cdkAutosizeMaxRows="5"
                                      cdkAutosizeMinRows="1"
                                      cdkTextareaAutosize
                                      class="white-space-pre"
                                      matInput></textarea>
                        </mat-form-field>
                    </div>
                </div>

                <div class="row form-row">
                    <div class="col-md-4">
                        <mat-form-field>
                            <mat-label>Autosize textarea infinite</mat-label>
                            <textarea #autosize="cdkTextareaAutosize"
                                      cdkAutosizeMinRows="1"
                                      cdkTextareaAutosize
                                      class="textarea-infinite white-space-pre"
                                      matInput
                                      placeholder="Textarea"></textarea>
                        </mat-form-field>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="container mt-5">
        <div class="section">
            <div class="section-header">
                <h3>Forms - app-output</h3>
            </div>
            <div class="section-content">
                <div class="row form-row">
                    <div class="col-4">
                        <app-output label="App output default">999</app-output>
                    </div>

                    <div class="col-4">
                        <mat-form-field>
                            <mat-label>Input label</mat-label>
                            <input matInput type="text">
                        </mat-form-field>
                    </div>
                </div>

                <div class="row form-row">
                    <div class="col-4">
                        <app-output label="App output left" align="left">999</app-output>
                    </div>

                    <div class="col-4">
                        <app-output label="App output center" align="center">999</app-output>
                    </div>

                    <div class="col-4">
                        <app-output label="App output right" align="right">999</app-output>
                    </div>

                </div>
            </div>
        </div>
    </div>

    <div class="container mt-5">
        <div class="section">
            <div class="section-header">
                <h3>numeric</h3>
            </div>
            <div class="section-content">
                <div class="row form-row">
                    <div class="col-4">
                        <div class="row form-row">
                            <div class="col-4">
                                <app-numeric [label]="'numeric regular'"></app-numeric>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row form-row">
                    <div class="col-4">
                        <div class="row form-row">
                            <div class="col-4">
                                <app-numeric [slim]="true"></app-numeric>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="container mt-5">
        <div class="section">
            <div class="section-header">
                <h3>forms</h3>
            </div>
            <div class="section-content">
                <h3>Dane polisowe</h3>
                <div class="row form-row">
                    <div class="col-4">
                        <mat-form-field appearance="fill">
                            <mat-label>Rodzaj polisy</mat-label>
                            <mat-select>
                                <mat-option *ngFor="let element of elements" [value]="element.value">
                                    {{element.viewValue}}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>
                </div>

                <div class="row form-row">
                    <div class="col-4">
                        <mat-form-field appearance="fill">
                            <mat-label>Numer polisy ubiegłorocznej</mat-label>
                            <input matInput placeholder="">
                        </mat-form-field>
                    </div>
                </div>

                <h3>Okres ochrony</h3>

                <div class="row form-row">
                    <div class="col-4">
                        <mat-form-field appearance="fill">
                            <mat-label>Enter a date range</mat-label>
                            <mat-date-range-input [rangePicker]="picker">
                                <input matStartDate placeholder="Start date">
                                <input matEndDate placeholder="End date">
                            </mat-date-range-input>
                            <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                            <mat-date-range-picker #picker></mat-date-range-picker>
                        </mat-form-field>
                    </div>

                </div>

                <h3>Dane nieruchomości</h3>

                <div class="row form-row">
                    <div class="col-4">
                        <mat-form-field appearance="fill">
                            <mat-label>Typ nieruchomości</mat-label>
                            <mat-select>
                                <mat-option *ngFor="let estate of estates" [value]="estate.value">
                                    {{estate.viewValue}}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>
                </div>

                <div class="row form-row">
                    <div class="col-2">
                        <mat-form-field appearance="fill">
                            <mat-label>Kod pocztowy</mat-label>
                            <input matInput placeholder="">
                        </mat-form-field>
                    </div>
                    <div class="col">
                        <mat-form-field appearance="fill">
                            <mat-label>Miejscowość</mat-label>
                            <input matInput placeholder="">
                        </mat-form-field>
                    </div>
                    <div class="col">
                        <mat-form-field appearance="fill">
                            <mat-label>Ulica</mat-label>
                            <input matInput placeholder="">
                        </mat-form-field>
                    </div>
                    <div class="col-2" style="max-width:120px;">
                        <mat-form-field appearance="fill">
                            <mat-label>Blok</mat-label>
                            <input matInput placeholder="">
                        </mat-form-field>
                    </div>
                    <div class="col-2" style="max-width:120px;">
                        <mat-form-field appearance="fill">
                            <mat-label>Mieszkanie</mat-label>
                            <input matInput placeholder="">
                        </mat-form-field>
                    </div>
                </div>
            </div>

        </div>
    </div>

    <div class="container mt-5">
        <div class="section">
            <div class="section-header">
                <h3>logo</h3>
            </div>
            <div class="section-content">

                <app-logo></app-logo>
            </div>
        </div>
    </div>

    <div class="container mt-5">
        <div class="section">
            <div class="section-header">
                <h3>logo project</h3>
            </div>
            <div class="section-content">

                <app-logo-project></app-logo-project>
            </div>
        </div>
    </div>

    <div class="container mt-5">
        <div class="section">
            <div class="section-header">
                <h3>icons</h3>
            </div>
            <div class="section-content">


                <div class="sg-icons mt-5">

                    <i class="icon-bin"></i>
                    <i class="icon-edit"></i>
                    <i class="icon-download"></i>
                    <i class="icon-download-2"></i>
                    <i class="icon-plus"></i>
                    <i class="icon-minus"></i>
                    <i class="icon-add"></i>
                    <i class="icon-close"></i>
                    <i class="icon-exit"></i>

                    <i class="icon-delete"></i>
                    <i class="icon-remove"></i>
                    <i class="icon-config"></i>
                    <i class="icon-settings"></i>
                    <i class="icon-calendar"></i>
                    <i class="icon-success"></i>
                    <i class="icon-danger"></i>
                    <i class="icon-warning"></i>
                    <i class="icon-info"></i>


                    <i class="icon-home"></i>
                    <i class="icon-car"></i>
                    <i class="icon-arrow-left"></i>
                    <i class="icon-arrow-right"></i>
                    <i class="icon-arrow-top"></i>
                    <i class="icon-arrow-bottom"></i>
                    <i class="icon-bottom"></i>
                    <i class="icon-top"></i>
                    <i class="icon-left"></i>
                    <i class="icon-right"></i>
                    <i class="icon-danger-filled"></i>
                    <i class="icon-warning-filled"></i>
                    <i class="icon-info-filled"></i>
                    <i class="icon-burger"></i>

                    <i class="icon-refresh"></i>
                    <i class="icon-print"></i>
                    <i class="icon-search"></i>
                    <i class="icon-search-big"></i>
                    <i class="icon-import"></i>
                    <i class="icon-export"></i>
                    <i class="icon-car-home"></i>

                    <i class="icon-new"></i>


                    <i class="icon-user"></i>
                    <i class="icon-user-edit"></i>
                    <i class="icon-user-add"></i>
                    <i class="icon-config-off"></i>
                    <i class="icon-customer"></i>
                    <i class="icon-dashboard"></i>
                    <i class="icon-card-index"></i><!--        icon registry-->


                    <i class="icon-edit-big"></i>
                    <i class="icon-preview"></i>
                    <i class="icon-timetable"></i>
                    <i class="icon-arrow-top-filed"></i>
                    <i class="icon-arrow-bottom-filed"></i>
                    <i class="icon-documents"></i>
                    <i class="icon-documents-download"></i>
                    <i class="icon-documents-delete"></i>
                    <i class="icon-new-tab"></i>

                    <i class="icon-oc-border"></i>
                </div>
            </div>
        </div>
        <br><br>
    </div>

    <div class="container mt-5">
        <div class="section">
            <div class="section-header">
                <h3>Aside</h3>
            </div>
            <div class="section-content">
                <div class="row">
                    <div class="col-2">
                        <button (click)="openAside()" class="btn btn-primary">Aside</button>
                    </div>
                    <div class="col-2">
                        <button (click)="openMenu()" class="btn btn-primary">MENU</button>
                    </div>
                    <div class="col-2">
                        <button (click)="openConfig()" class="btn btn-primary">Config aside</button>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="container mt-5">
        <div class="section">
            <div class="section-header">
                <h3>Dialog</h3>
            </div>
            <div class="section-content">
                <button class="btn btn-primary" (click)="openDialog()">dialog</button>
            </div>
        </div>
    </div>

    <div class="container mt-5">
        <div class="section">
            <div class="section-header">
                <h3>Blocker</h3>
            </div>
            <div class="section-content">
                <button class="btn btn-primary" (click)="openBlocker()">block 5s</button>
            </div>
        </div>
    </div>

    <div class="container mt-5">
        <div class="section">
            <div class="section-header">
                <h3>Blocker, dialog, toaster</h3>
            </div>
            <div class="section-content">
                <button class="btn btn-primary" (click)="openBlockerDialog()">Blocker, dialog, toaster</button>
            </div>
        </div>
    </div>

    <div class="container mt-5">
        <div class="section">
            <div class="section-header">
                <h3>Toaster</h3>
            </div>
            <div class="section-content">
                <div class="row">
                    <div class="col-3">
                        <button (click)="showInfoToaster()" class="btn btn-primary">Toaster info</button>
                    </div>
                    <div class="col-3">
                        <button (click)="showSuccessToaster()" class="btn btn-secondary">Toaster success</button>
                    </div>
                    <div class="col-3">
                        <button (click)="showWarningToaster()" class="btn btn-secondary">Toaster warning</button>
                    </div>
                    <div class="col-3">
                        <button (click)="showErrorToaster()" class="btn btn-secondary">Toaster error</button>
                    </div>
                </div>
                <div class="row">
                    <div class="col">
                        <div class="toast-container">
                            <div class="toast-info ngx-toastr ng-trigger ng-trigger-flyInOut"
                                 style="opacity: 1;">
                                <div aria-label="Toastr fun!" class="toast-title ng-star-inserted" style=""> Toastr
                                    fun!
                                </div>
                                <div aria-label="Hello world!" aria-live="polite"
                                     class="toast-message ng-star-inserted"
                                     role="alertdialog" style=""> Hello world!
                                </div>
                            </div>

                            <div class="toast-success ngx-toastr ng-trigger ng-trigger-flyInOut"
                                 style="opacity: 1;">
                                <div aria-label="Toastr fun!" class="toast-title ng-star-inserted" style=""> Toastr
                                    fun!
                                </div>
                                <div aria-label="Hello world!" aria-live="polite"
                                     class="toast-message ng-star-inserted"
                                     role="alertdialog" style=""> Hello world!
                                </div>
                            </div>

                            <div class="toast-warning ngx-toastr ng-trigger ng-trigger-flyInOut"
                                 style="opacity: 1;">
                                <div aria-label="Toastr fun!" class="toast-title ng-star-inserted" style=""> Toastr
                                    fun!
                                </div>
                                <div aria-label="Hello world!" aria-live="polite"
                                     class="toast-message ng-star-inserted"
                                     role="alertdialog" style=""> Hello world!
                                </div>
                            </div>

                            <div class="toast-error ngx-toastr ng-trigger ng-trigger-flyInOut"
                                 style="opacity: 1;">
                                <div aria-label="Toastr fun!" class="toast-title ng-star-inserted" style=""> Toastr
                                    fun!
                                </div>
                                <div aria-label="Hello world!" aria-live="polite"
                                     class="toast-message ng-star-inserted"
                                     role="alertdialog" style=""> Hello world!
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="container mt-5">
        <div class="section">
            <div class="section-header">
                <h3>Alert</h3>
            </div>
            <div class="section-content">
                <app-alert><strong>strong</strong> default</app-alert>

                <app-alert alertType="info"><strong>strong!</strong> Alert info
                </app-alert>
                <app-alert alertType="danger"><strong>strong</strong> Alert danger
                </app-alert>
                <app-alert alertType="warning"><strong>strong</strong> Alert warning
                </app-alert>
                <app-alert alertType="success"><strong>strong</strong> alert success
                </app-alert>
            </div>
        </div>
    </div>

    <div class="container mt-5">
        <div class="section">
            <div class="section-header">
                <h3>Clausules</h3>
            </div>
            <!--        client-->
            <div class="section-content">
                <h3>{{'CLIENT_DECLARATIONS_CONDITIONS' | translate}}</h3>
                <p>{{'CLIENT_DECLARATION_INFO' | translate}}</p>
                <div class="form-row">
                    <div class="col">
                        <app-checkbox [(ngModel)]="checked">{{'CLIENT_DECLARATION_1' | translate}} <a href=""
                                                                                                      class="link link-accent">{{'READ_MORE' | translate}}</a>
                        </app-checkbox>
                    </div>

                </div>
                <div class="form-row">
                    <div class="col">
                        <app-checkbox [(ngModel)]="checked">{{'CLIENT_DECLARATION_2' | translate}}</app-checkbox>
                    </div>

                </div>


                <!--            agent-->
                <h3>{{'AGENT_DECLARATIONS' | translate}}</h3>
                <div class="form-row">
                    <div class="col">
                        <app-checkbox [(ngModel)]="checked">{{'SELECT_ALL_DECLARATIONS' | translate}}</app-checkbox>
                    </div>
                </div>

                <div class="form-row">
                    <div class="col">
                        <app-checkbox [(ngModel)]="checked">{{'AGENT_DECLARATION_1' | translate}}</app-checkbox>
                    </div>
                </div>

                <div class="form-row">
                    <div class="col">
                        <app-checkbox [(ngModel)]="checked"
                                      [disabled]="true">{{'AGENT_DECLARATION_2' | translate}}</app-checkbox>
                    </div>
                </div>

                <div class="form-row">
                    <div class="col">

                        <app-checkbox [(ngModel)]="checked"
                                      [disabled]="true">{{'AGENT_DECLARATION_3' | translate}}</app-checkbox>
                    </div>
                </div>

                <!--            clauses-->

                <!--            agent-->
                <h3>{{'CLIENT_CONDITIONS' | translate}}</h3>
                <p>{{'CLIENT_CONDITION_1' | translate}}</p>
                <div class="form-row">
                    <div class="col">
                        <app-checkbox [(ngModel)]="checked">{{'CLIENT_CONDITION_1' | translate}}</app-checkbox>
                    </div>
                </div>
                <p class="checkbox-extend">{{'CLIENT_CONDITION_1_EXTENDED' | translate }}</p>

                <div class="form-row">
                    <div class="col">
                        <app-checkbox [(ngModel)]="checked">{{'CLIENT_CONDITION_2' | translate}}</app-checkbox>
                    </div>
                </div>
                <p class="checkbox-extend">{{'CLIENT_CONDITION_2_EXTENDED' | translate }}</p>
            </div>
        </div>
    </div>

    <div class="container mt-5">
        <div class="section">
            <div class="section-header">
                <h3>box</h3>
            </div>
            <!--        client-->
            <div class="section-content">

                <div class="box box-white has-shadow">
                    <div class="box-header box-body">

                        <div class="box-header-icon">
                            <i class="icon-home"></i>
                        </div>

                        <div class="box-header-title">
                            {{ 'OFFER_CONFIG.WELTH' | translate }}
                        </div>

                        <div class="box-action text-accent">
                            <button class="btn btn-link btn-slim">
                                <i class="icon-settings mr-2"></i>
                                <span>{{'CONFIGURE' | translate }}</span>
                            </button>
                        </div>
                    </div>

                    <div class="box-content">
                        <div class="box-body">
                            <div class="box-row has-padding">
                                <div class="box-item flex-column">
                                    <div class="row">
                                        <div class="col-3">
                                            <app-output [label]="'OFFER_CONFIG.ESTATE_TYPE' | translate">
                                                en.property_type.flat
                                            </app-output>
                                        </div>
                                        <div class="col-3">
                                            <app-output [label]="'INSURED_OBJECT' | translate">
                                                80-280 Gdańsk, Słonimskiego 2/2
                                            </app-output>
                                        </div>
                                        <div class="col-3">
                                            <app-output [label]="'OFFER_CONFIG.PROTECTION_PERIOD' | translate">
                                                12.12.2020 - 12.12.2020
                                            </app-output>
                                        </div>
                                    </div>

                                    <div class="row">
                                        <div class="col">
                                            <app-output [label]="'OFFER_CONFIG.INSURANCE_COVERAGE' | translate">
                                                Mieszkanie
                                            </app-output>
                                        </div>
                                    </div>
                                </div>

                                <div class="box-item box-item-action align-self-center justify-content-end">
                                    <div class="col-auto">
                                        <button class="btn btn-link btn-slim"
                                                [matTooltip]="'TOOLTIP.DELETE_PRODUCT' | translate">
                                            <i class="icon-delete mr-1"></i>
                                        </button>


                                        <button class="btn btn-link btn-slim"
                                                [matTooltip]="'TOOLTIP.EDIT_PRODUCT' | translate">
                                            <i class="icon-edit"></i>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="box-footer">
                        <div class="box-body">
                            <div class="row no-gutters">

                                <div class="installment">
                                    <div class="installment-title">
                                        {{ 'OFFER_CONFIG.PAYMENTS' | translate }}
                                    </div>

                                    <div class="installment-body">
                                        <div class="installment-item">
                                            <div class="item-price">1 345 zł</div>
                                            <div class="item-date">12.12.2020</div>
                                        </div>
                                        <div class="installment-item">
                                            <div class="item-price">1 345 zł</div>
                                            <div class="item-date">12.12.2020</div>
                                        </div>
                                        <div class="installment-item">
                                            <div class="item-price">1 345 zł</div>
                                            <div class="item-date">12.12.2020</div>
                                        </div>
                                        <div class="installment-item">
                                            <div class="item-price">1 345 zł</div>
                                            <div class="item-date">12.12.2020</div>
                                        </div>
                                    </div>
                                </div>

                                <div class="col"></div>


                                <div class="text-price column">
                                    <div class="item-text">{{ 'LABEL.PREMIUM' | translate }}</div>
                                    <div class="item-price">2 123 zł</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="container mt-5">
        <div class="section">
            <div class="section-header">
                <h3>price with edit</h3>
            </div>
            <div class="section-content">
                <div class="box mt-3">
                    <div class="box-body">
                        <div class="row no-gutters">
                            <div class="col"></div>
                            <div class="col-auto">
                                <div class="text-price ml-0">
                                    <div class="item-text">{{'OFFER_CONFIG.TOTAL_PREMIUM' | translate}}</div>
                                    <div class="item-price">23,34pln</div>
                                    <div class="item-icon">
                                        <button class="btn btn-link btn-no-padding"
                                                [matTooltip]="'TOOLTIP.EDIT_PREMIUM' | translate">
                                            <i class="icon-edit"></i>
                                        </button>
                                    </div>
                                </div>
                                <mat-error>
                                    error here
                                </mat-error>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="container mt-5">
        <div class="section">
            <div class="section-header">
                <h3>list</h3>
            </div>
            <div class="section-content">

                <ul class="list-no-margin">
                    <li>
                        <a target="_blank" class="btn btn-link btn-no-padding"><span>91000000001027</span>
                            <i class="icon-new-tab ml-1"></i>
                        </a>
                    </li>
                    <li>
                        <a target="_blank" class="btn btn-link btn-no-padding"><span>91000000001027</span>
                            <i class="icon-new-tab ml-1"></i>
                        </a>
                    </li>
                    <li>
                        <a target="_blank" class="btn btn-link btn-no-padding"><span>91000000001027</span>
                            <i class="icon-new-tab ml-1"></i>
                        </a>
                    </li>
                </ul>
            </div>
        </div>
    </div>


    <div class="container mt-5">
        <div class="section">
            <div class="section-header">
                <h3>empty</h3>
            </div>
            <div class="section-content">

                <app-empty>lorem ipsum kotum</app-empty>
                <app-empty [iconClass]="'icon-search-big'" class="mt-2">lorem ipsum kotum</app-empty>
            </div>
        </div>
    </div>


    <div class="container mt-5">
        <div class="section">
            <div class="section-header">
                <h3>grid</h3>
            </div>
            <div class="section-content">

                <div class="row">
                    <div class="col">test</div>
                    <div class="col-auto">test</div>
                </div>
            </div>
        </div>
    </div>
</div>
